export default "__VITE_ASSET__CLbrrbtA__"